export const DEFAULT_DATE_OPTIONS = [
  {
    value: 'mtd',
    label: 'This Month to Date',
  },
  {
    value: 'pm',
    label: 'Previous Month',
  },
  {
    value: 'ytd',
    label: 'This Year to Date',
  },
  {
    value: '7',
    label: 'Last 7 Days',
  },
  {
    value: '30',
    label: 'Last 30 Days',
  },
  {
    value: '90',
    label: 'Last 90 Days',
  },
  {
    value: '365',
    label: 'Last 365 Days',
  },
  {
    value: 'custom',
    label: 'Custom',
  },
];
